import { startLoading, stopLoading } from "../../common/utils/button-loading";
import { submitSubscribeForm } from "../services/subscribe-form-service";

declare var pmRunRecaptchaAjaxForm: any;

export function setupSubscribeForm(form: HTMLFormElement) {
	const { emptyElement } = pm.utils.dom;
	const notice = pm.utils.notice;

	const submitButton = form.querySelector(
		'button[type="submit"]',
	) as HTMLButtonElement | null;
	if (!submitButton) return;

	const fieldsGroup = form.querySelector(
		".mailerlite-form-inputs",
	) as HTMLElement | null;
	if (!fieldsGroup) return;

	const nameField = form.querySelector(
		'[name="name"]',
	) as HTMLInputElement | null;
	if (!nameField) return;

	const emailField = form.querySelector(
		'[name="email"]',
	) as HTMLInputElement | null;
	if (!emailField) return;

	const submissionResponse = form.querySelector(
		".submission-response",
	) as HTMLElement | null;
	if (!submissionResponse) return;

	const useRecaptcha = form.dataset.useRecaptcha === "1";

	form.addEventListener("submit", handleFormSubmission);

	let doingAjax = false;

	async function handleFormSubmission(ev: SubmitEvent) {
		ev.preventDefault();

		if (doingAjax) return;
		doingAjax = true;

		notice.hide(submissionResponse as HTMLElement, true);

		if (submitButton) {
			startLoading(submitButton);
		}

		if (!window["pmRunRecaptchaAjaxForm"]) {
			alert("missing grecaptcha");
			return;
		}

		if (useRecaptcha) {
			pmRunRecaptchaAjaxForm("contact_form_submission", submitWithToken);
			return;
		}

		await submitWithToken("");
	}

	async function submitWithToken(recaptchaToken: string) {
		const formData = new FormData(form as HTMLFormElement);

		if (useRecaptcha) {
			formData.append("recaptcha_token", recaptchaToken);
		}

		const response = await submitSubscribeForm(formData);

		doingAjax = false;

		stopLoading(submitButton);

		if (!response.success) {
			notice.show(
				submissionResponse as HTMLElement,
				response.message ?? "An unknown error occurred.",
				"failed",
				true,
			);

			return;
		}

		const successMsg = response.message ?? response.data;

		notice.show(submissionResponse as HTMLElement, successMsg, "success", true);

		if (fieldsGroup) {
			emptyElement(fieldsGroup);
		}
	}
}
